var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_vm._v("登录中1。。。"+_vm._s(_vm.$route.query.code))])}
var staticRenderFns = []

export { render, staticRenderFns }